export const resolveStudentParentFields = ({
  ogrenciAd,
  ogrenciSoyad,
  veliAd,
  veliSoyad,
} = {}) => {
  const studentFirstName = String(ogrenciAd || '').trim();
  const studentLastName = String(ogrenciSoyad || '').trim();
  const parentFirstName = String(veliAd || '').trim();
  const parentLastName = String(veliSoyad || '').trim();

  if (parentFirstName && parentLastName) {
    return { veli_ad: parentFirstName, veli_soyad: parentLastName };
  }

  return {
    veli_ad: [studentFirstName, studentLastName].filter(Boolean).join(' ') || 'Öğrenci',
    veli_soyad: '(Velisi)',
  };
};
